export const LOAD_GRADIENTS = "LOAD_GRADIENTS";
export const GET_GRADIENTS = "GET_GRADIENTS";
export const CREATE_GRADIENT = "CREATE_GRADIENT";
export const UPDATE_GRADIENT = "UPDATE_GRADIENT";
export const DELETE_GRADIENT = "DELETE_GRADIENT";
export const SET_GRADIENT = "SET_GRADIENT";
export const REMOVE_GRADIENT = "REMOVE_GRADIENT";
export const DOWNLOAD_GRADIENT = "DOWNLOAD_GRADIENT";